import { v4 as uuidv4 } from "uuid";

const STORAGE_KEY = "cadviewer.endUserId";

export function getOrCreateEndUserId(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing) return existing;
    const fresh = uuidv4();
    localStorage.setItem(STORAGE_KEY, fresh);
    return fresh;
  } catch {
    return uuidv4();
  }
}
